export enum AdminRoutesPath {
  HOME = '/admin',
}
